export const PATHS_WITH_QUERY_PARAMS = [
  '/developers',
  '/repos',
  '/tags',
  '/ai-adoption',
  '/ai-leverage/developers',
  '/ai-leverage/repositories',
  '/ai-leverage/projects',
  '/categories',
  '/projects',
  '/repo-report',
  '/project-report',
  '/',
  '/commit-details'
];

export const REMOVE_FROM_URLSEARCH = {
  '/ai-leverage/developers': ['authors'],
  '/ai-leverage/repositories': ['repos'],
  '/ai-leverage/projects': ['projects', 'repos'],
  '/developers': ['authors'],
  '/repos': ['repos'],
  '/categories': ['categories'],
  '/projects': ['projects'],
  '/tags': ['tags'],
  '/': ['operation'], // overview
  '*': ['language_tags']
};

// Legacy SIDEBAR_ITEMS - now generated dynamically from routes.js
// This is kept for backward compatibility but will be replaced by getSidebarItems
export const SIDEBAR_ITEMS = {
  nodes: []
};
